import React from 'react';
import {IElementQuestionnaireWithAnswers} from '../../../../../../incase-domain/elements/base/questionElementBase';
import Button from '../../../../../../incase-domain/components/button/Button';

interface IRemoveAnswerProps {
    index: number;
    highlightedElement: IElementQuestionnaireWithAnswers;
    removeAnswer: (index: number) => void;
}

function RemoveAnswer({index, highlightedElement, removeAnswer}: IRemoveAnswerProps): JSX.Element {
    return (
        <Button
            variant="ghost"
            color="error"
            square
            size="sm"
            leading="solar:trash-bin-minimalistic-linear"
            key={`${index}-delete`}
            onClick={() => removeAnswer(index)}
            disabled={highlightedElement.answers.length < 2}
            data-cy="removeAnswer"
        />
    );
}

export default RemoveAnswer;
